import { HeadlessFormProvider } from '@delmonicos/shared-design-system-react/src/contexts/headless-form.provider';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetLocationsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/locations/get-locations-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterSearchEmspBoLocationListContext } from '../../../emsp-bo-location.context';
import { EmspBoLocationListFilterSearchFormStep1Controller } from '../emsp-bo-location-list-filter-search-form-step-1/emsp-bo-location-list-filter-search-form-step-1.controller';

export interface EmspBoLocationListFilterSearchFormControllerProps {
  onError: SubmitErrorHandler<GetLocationsPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetLocationsPaginatedModel>;
  onCancel: () => void;
}

export const EmspBoLocationListFilterSearchFormController = (
  props: EmspBoLocationListFilterSearchFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel } = props;
  const data = useFilterSearchEmspBoLocationListContext();

  return (
    <HeadlessFormProvider<GetLocationsPaginatedModel>
      useFormProps={{ mode: 'all', defaultValues: data }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      item={{
        fields: ['textToSearch'],
        component: <EmspBoLocationListFilterSearchFormStep1Controller />,
      }}
    />
  );
};
